<div class="validate">
    <div class="title centered-container" *ngIf="loading">
        <h2>Validating</h2>
    </div>
    <div class="title centered-container" *ngIf="!loading">
        <h2>Review Validation / Promote to Live</h2>
        <button class="inline icon question" title="Help" (click)="toggleHelp()">
            <span class="icon icon-ui-question"></span>
        </button>
    </div>
    <div class="centered-container" *ngIf="!loading">
        <div class="show-results-stats centered-container" *ngIf="service.showResultsStats">
            <div class="centered-container">
                <div class="help" *ngIf="showHelp">
                    <button class="icon inline close" (click)="toggleHelp()">
                        <span class="icon icon-ui-close"></span>
                    </button>
                    <h3>What Now?</h3>
                    <p>Your data has been validated and moved into stage tables. You can view the results below.</p>
                    <p><strong>Promote Validated Data</strong> moves your project data to the "live" tables so that the
                        points and lines can be accessed by mapping applications. If you have no "promotable" rows, this
                        button will not be visible.</p>
                    <p><strong>Start A New File</strong> allows you to go back to the beginning to import a new data
                        file. You can then add more data to this project or create another project.</p>
                    <p><strong>Go Back to Field Mapping</strong> allows you to go back to adjust the field/column
                        mappings. (Maybe a field was not mapping correctly and is causing a ton of errors?)</p>
                    <p><strong>Trash this Project</strong> completely deletes what you just did and deletes your
                        project. You cannot delete projects that have already been promoted to live.</p>
                    <h4>Results Explained</h4>
                    <p><strong>Validated</strong> No problems with the data in these rows </p>
                    <p><strong>Warnings</strong> The rows contain faulty data, but not enough to cause an issue. The
                        data can still be promoted.</p>
                    <p><strong>Errors</strong> The rows have issues that will cause them to fail. These rows will not be
                        promoted.</p>
                    <p><strong>Empty Rows</strong> Rows that are empty.</p>
                    <p><strong>Rows Processed</strong> The total number of rows processed. (Not including header rows.)
                    </p>
                    <p><strong>Promotable Rows</strong> Rows that can be promoted to production for this file. (Sum of
                        validated and warnings rows.)</p>
                    <p>Click <strong>Show Error Details</strong> to view a table displaying why certain rows failed. The
                        Row Number matches the row number shown in Excel.</p>
                </div>
            </div>
            <div class="centered-container">
                <div class="results-stats">
                    <div><label>Project Id:</label>{{ service.project.id }}</div>
                    <div><label>Project Description:</label>{{ service.project.description }}</div>
                    <div><label>Files Processed:</label>{{ service.project.scenarios.length }}</div>
                    <div><label>Staged Totals:</label> Points: {{ service.project.stagePointCount }} Lines:
                        {{ service.project.stageLineCount }}</div>
                    <div><label>Lifespan:</label>{{ service.project.lifeSpanDays }} days</div>
                    <table class="table">
                        <tbody>
                            <tr>
                                <td>Validated</td>
                                <td class="value"><span
                                        class="label label-success">{{ validationReport.validatedRows }}</span></td>
                            </tr>
                            <tr>
                                <td>Warnings</td>
                                <td class="value"><span
                                        class="label label-warning">{{ validationReport.warningRows }}</span></td>
                            </tr>
                            <tr>
                                <td>Errors</td>
                                <td class="value"><span
                                        class="label label-danger">{{ validationReport.validationErrors }}</span>
                                </td>
                            </tr>
                            <tr>
                                <td>Empty Rows</td>
                                <td class="value"><span
                                        class="label label-default">{{ validationReport.emptyDataRows }}</span></td>
                            </tr>
                            <tr class="totals">
                                <td>Rows Processed</td>
                                <td class="value"><span
                                        class="label label-primary">{{ validationReport.totalRowsProcessed }}</span>
                                </td>
                            </tr>
                            <tr class="totals">
                                <td>Promotable Rows</td>
                                <td class="value"><span
                                        class="label label-success">{{ validationReport.validatedRows + validationReport.warningRows }}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="show-issues-link centered-container">
                        <button class="btn red" (click)="toggleShowIssues()"
                            [disabled]="service.validationReport.fileIssueList.length === 0">
                            <span class="icon icon-ui-layer-list"></span>
                            <span *ngIf="!showIssues">Show</span>
                            <span *ngIf="showIssues">Hide</span>
                            Error Details
                        </button>
                    </div>
                </div>
            </div>
            <div class="centered-container">
                <div class="issues" *ngIf="showIssues">
                    <table class="table table-bordered">
                        <thead>
                            <th class="row-number" (click)="sortIndex = 0">Row</th>
                            <th (click)="sortIndex = 1">Reason</th>
                        </thead>
                        <tr *ngFor="let row of service.validationReport.fileIssueList">
                            <td class="row-number">{{ row.rowNumber }}</td>
                            <td>
                                <div class="issue" *ngFor="let issue of row.issueList">
                                    <span class="label issue-type {{ issue.cssClass }}">{{ issue.type }}</span>
                                    {{ issue.columnName }} - {{ issue.issueDetail }}
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="centered-container"
                *ngIf="enablePromote && (service.project.pointCount > 0 || service.project.lineCount > 0) && !service.promoteErrorOccurred">
                <div class="warning-message-container">
                    <div class="service-error" role="alert">
                        <strong>Warning! Promoting this data will delete the existing production data for this
                            project.</strong>
                        <div>Production Points: {{ service.project.pointCount }}</div>
                        <div>Production Lines: {{ service.project.lineCount }}</div>
                    </div>
                </div>
            </div>
            <div class="centered-container promote-error" *ngIf="service.promoteErrorOccurred">
                <div class="error-message-container">
                    <div class="service-error alert alert-danger" role="alert">
                        <strong>An error occurred during the promotion process.</strong>
                    </div>
                </div>
                <p>Click <strong>Promote Validated Data Again</strong> to promote each record one by one and
                    discard any records that caused an error. This process is much slower than the normal
                    promote process.
                    You can also try going back to field mapping or uploading a different file.</p>
            </div>
        </div>
        <div class="next-previous-buttons">
            <div class="centered-container button-group">
                <button type="button" class="btn red" (click)="goBackToMapping();">
                    <span class="icon icon-ui-left-arrow"></span>
                    Go Back to Field Mapping
                </button>
                <button type="button" class="btn red trash" (click)="trash();" *ngIf="projectIsTrashable">
                    <span class="icon icon-ui-trash"></span>
                    Trash this Project
                </button>
                <button type="button" class="btn btn-primary btn-lg" (click)="promoteData()" *ngIf="enablePromote">
                    <span class="icon icon-ui-right-arrow"></span>
                    {{ successLevelText }} Promote Validated Data
                    <span *ngIf="service.promoteErrorOccurred">Again</span>
                </button>
            </div>
        </div>
    </div>
</div>
